class Apis {
    constructor(api) {
        this.URI = "api/" + api + ".php";
    }

    async procesar(param) {
  
        let dat = {"error":true, "relogin":false, "mensaje": "Se produjo algún error al ejecutar la solicutd."};

        let resultado = await fetch(this.URI, {
            method: "POST",
            body: param,
            cache: "no-cache"
        });
        
        if (resultado.ok) {
            dat = await resultado.json();
        }else{
            console.log("ERROR");
        }

        return dat;
    }
}

export default Apis;